module.exports = __webpack_public_path__ + "static/5-fbbd270505ebe5c6c78af2513ed6643a.jpg";